import {OFFICE_SETTINGS_FETCH_SUCCESS, OFFICE_SETTINGS_FETCH_FAILURE, OFFICE_SETTINGS_FETCH_REQUEST} from './officeSettingsConstants';
import {officeSettingsService} from '_app/services';

const fetchOfficeSettingsRequest = {
	type: OFFICE_SETTINGS_FETCH_REQUEST
};

const fetchOfficeSettingsFailure = {
	type: OFFICE_SETTINGS_FETCH_FAILURE
};

const fetchOfficeSettingsSuccess = data => ({
	type: OFFICE_SETTINGS_FETCH_SUCCESS,
	data
});

export const fetchOfficeSettings = partnerId => dispatch => {
	dispatch(fetchOfficeSettingsRequest);

	return officeSettingsService.get(partnerId)
		.then(data => dispatch(fetchOfficeSettingsSuccess(data)))
		.catch(() => dispatch(fetchOfficeSettingsFailure));
};

export const updateOfficeSettings = office => dispatch => (
	officeSettingsService.update(office)
		.then(() => dispatch(fetchOfficeSettings(office.partnerID)))
);

export const getPublicSettings = (token, isCampaign) => dispatch => {
	dispatch(fetchOfficeSettingsRequest);

	return officeSettingsService.public(token, isCampaign)
		.then(data => dispatch(fetchOfficeSettingsSuccess(data)))
		.catch(() => dispatch(fetchOfficeSettingsFailure));
};